<template>
  <div id="decisionLogic" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Instant Bank Verification</v-toolbar-title>
    </v-toolbar>
    <v-container class="ibv-container">
      <v-layout style="align-items: center">
        <div class="top-title">
          <div class="f-s-18 m-r-5">Provider：</div>
          <v-select
              style="width: 180px"
              :items="providerOptions"
              v-model="providerDefault"
              hide-details
              item-text="text"
              item-value="value"
          >
          </v-select>
          <img
              :src="providerUrl"
              class="height-30 m-l-5"
          />
        </div>
        <v-spacer></v-spacer>
        <v-slide-group v-if="loan.loanStatus < datatype.LoanStatus.APPROVED.value">
          <v-slide-item>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#5C82E3"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="m-h-5"
                  @click="createRequestCodeHandler"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Create Request Code</span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item v-if="isShowInstantRefresh">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#5C82E3"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="m-h-5"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <span>Instant Refresh</span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item v-if="isShowSearch">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#5C82E3"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="m-h-5"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <span>Search</span>
            </v-tooltip>
          </v-slide-item>
        </v-slide-group>
      </v-layout>
      <!--   Chirp   -->
      <template v-if="isShowChirpData && providerDefault === datatype.IBVProviderType.CHIRP.value">
        <Chirp :dataSource="dataSource" :loanData="loanData" :loan="loan"></Chirp>
      </template>
      <!--   Decision Logic   -->
      <template v-else-if="isShowDLData && providerDefault === datatype.IBVProviderType.DECISION_LOGIC.value">
        <!-- request -->
        <v-card elevation="0" v-if="isShowRequest">
          <v-card-title>Request (Information Entered)</v-card-title>
          <v-card-text style="padding-left: 46px">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="field-name">Request Code</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.requestCode }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Customer Id</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.loanNo }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.firstName }} {{ loanData.middleName }} {{ loanData.lastName }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Institution Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.bankName }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Email Address</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.email }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Routing Number</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.routingNo }} <span v-if="ibvRequestCodeData.isACHSupported">(ACH Supported)</span></label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Profile</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.portfolioText }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Account Number</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.accountNo }}</label>
              </v-flex>
            </v-layout>

            <v-card class="width-80p" style="margin: 0 auto;" v-if="false">
              <v-card-title>
                <span>Income Stability Score (range 1 ~ 100):</span><span class="text-primary">75.25</span><sup>*</sup>
              </v-card-title>
              <v-card-text style="line-height: 1!important;">
                <i class="f-s-10">* This score is derived from DecisionLogic's unique scoring model. It is derived from historical bank data and is not to be confused with a credit score as that provided from credit reporting agencies. This score may be different than that used by other agencies.</i>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>

        <!-- response -->
        <v-card elevation="0" v-if="isShowRequest">
          <v-card-title>Response (Information Returned by Bank)
            <v-btn v-if="loan.loanStatus < datatype.LoanStatus.APPROVED.value" class="m-l-10" small icon color="#5C82E3" @click="getStatusData()">
              <v-icon>sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding-left: 46px">
            <v-layout row wrap>
              <v-flex lg3>
                <label class="field-name">Login</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.isLoginValid ? 'Successful' : 'Failure' || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Account Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.accountName || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.nameFound || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Account Type</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.accountType || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Status</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.statusText || 'Not Started' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Routing Number</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ ibvRequestCodeData.routingNumberReturned || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name"></label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value"></label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Account Number</label>
              </v-flex>
              <v-flex lg2>
                <label v-if="assist.tool.isEmpty(ibvRequestCodeData.accountNumberFound)" class="field-value">N/A</label>
                <v-select
                  v-else
                  v-model="ibvResponseCodeData.accountNumberFound"
                  :items="accountNumberItem"
                  dense
                  hide-details
                  height="15"
                  class="field-value"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <!-- notes -->
        <v-card elevation="0" v-if="isShowResponse">
          <v-card-title>Notes</v-card-title>
          <v-card-text class="notes-content" style="padding-left: 30px">
            <div v-html="notes"></div>
          </v-card-text>
        </v-card>

        <!-- summary -->
        <v-card elevation="0" v-if="isShowResponse">
          <v-card-title>Summary</v-card-title>
          <v-card-text>
            <v-layout row wrap style="height: 100px; margin-bottom: 8px; padding-left: 36px;">
              <v-flex lg3>
                <label class="field-name">Available Balance</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.availableBalance) || 'N/A'}}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">As of Date</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatDate(ibvRequestCodeData.asOfDate) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Current Balance</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.currentBalance) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Average Balance</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.averageBalance) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Deposits/Credits</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.totalCredits) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Avg Bal Latest Month</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.averageBalanceRecent) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Withdrawals/Debits</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ assist.tool.formatCurrency(ibvRequestCodeData.totalDebits) || 'N/A' }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Workflow</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">New</label>
              </v-flex>
            </v-layout>

            <v-simple-table
              height="195"
              fixed-header
              dense
            >
              <thead>
              <tr>
                <th class="text-left p-l-26">Description</th>
                <th class="text-left">Code</th>
                <th class="text-right">Transactions</th>
                <th class="text-right">Total</th>
                <th class="text-right">
                  <strong>Transactions Last Month</strong>
                  <div class="f-w-400">({{ assist.tool.formatDate(ibvRequestCodeData.activityStartDate) || 'N/A' }} - {{ assist.tool.formatDate(ibvRequestCodeData.activityEndDate) || 'N/A' }})</div>
                </th>
                <th class="text-right">
                  <strong>Total Last Month</strong>
                  <div class="f-w-400">({{ assist.tool.formatDate(ibvRequestCodeData.activityStartDate) || 'N/A' }} - {{ assist.tool.formatDate(ibvRequestCodeData.activityEndDate) || 'N/A' }})</div>
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-if="assist.tool.isNotEmpty(ibvRequestCodeData.transactionAnalysisSummaries)">
                <tr v-for="(item, index) in ibvRequestCodeData.transactionAnalysisSummaries.transactionAnalysisSummary5" :key="index">
                  <td class="text-left p-l-26">{{ item.typeName }}</td>
                  <td class="text-left">{{ item.typeCode }}</td>
                  <td class="text-right">{{ item.totalCount }}</td>
                  <td class="text-right">{{ assist.tool.formatCurrency(item.totalAmount) }}</td>
                  <td class="text-right">{{ item.recentCount }}</td>
                  <td class="text-right">{{ assist.tool.formatCurrency(item.recentAmount) }}</td>
                </tr>
              </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <!-- transactions -->
        <v-card elevation="0" v-if="isShowResponse">
          <v-card-title>Transactions</v-card-title>
          <v-card-text>
            <v-data-table
              class="m-b-30"
              v-model="selected"
              :headers="transactionsHeaders"
              :items="transactionSummary5"
              item-key="index"
              dense
              show-select
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.transactionDate="{ item }">
                <td style="white-space: nowrap" :class="decideStatus(item)">{{ assist.tool.formatDate(item.transactionDate) }}</td>
              </template>
              <template v-slot:item.status="{ item }">
                <td style="white-space: nowrap" :class="decideStatus(item)">{{ assist.tool.isNotEmpty(item.status) ? item.status.substr(0,1).toUpperCase() + item.status.substr(1) : '' }}</td>
              </template>
              <template v-slot:item.category="{ item }">
                <td :class="decideStatus(item)">{{ item.category }}</td>
              </template>
              <template v-slot:item.typeCodes="{ item }">
                <td style="white-space: nowrap" :class="decideStatus(item)">{{ item.typeCodes }}</td>
              </template>
              <template v-slot:item.description="{ item }">
                <td :class="decideStatus(item)">{{ item.description }}</td>
              </template>
              <template v-slot:item.amount="{ item }">
                <td :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.amount) }}</td>
              </template>
              <template v-slot:item.runningBalance="{ item }">
                <td :class="decideStatus(item)">{{ assist.tool.formatCurrency(item.runningBalance) }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
      <div v-else>
        <h3 class="text-center">No {{assist.tool.getEnumTextByValue(datatype.IBVProviderType, providerDefault)}} Display</h3>
      </div>

      <v-dialog v-model="isShowCreateRequestCodeDialog" max-width="1000px">
        <v-card>
          <v-card-title class="dialog-title">
            <span class="headline">Create Request Code</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="isShowCreateRequestCodeDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="dialog-text">
            <v-layout class="dialog-layout" row wrap>
              <v-flex lg3>
                <label class="field-name">Customer Id</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.loanNo }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.firstName }} {{ loanData.middleName}} {{ loanData.lastName }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Institution Name</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.bankName }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">profile</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.portfolioText }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Routing Number</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.routingNo }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Email Address</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.email }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Account Number</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.accountNo }}</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-name">Cell Phone</label>
              </v-flex>
              <v-flex lg3>
                <label class="field-value">{{ loanData.cellPhone }}</label>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="isShowCreateRequestCodeDialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="createRequestCode">Create Request Code</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <div v-if="isShowDLData && providerDefault === datatype.IBVProviderType.DECISION_LOGIC.value && loanStatusEnum.includes(loan.loanStatus)" class="manual-select-content">
      <v-btn
        dark
        small
        tile
        color="#5C82E3"
        class="btn-action position-abs"
        @click="manualSelectBankRecords">
        Manual Select Bank Records
      </v-btn>
    </div>
  </div>
</template>

<script>
import { RuntimeApi, OriginationApi, LoanResourceApi } from '@/api/pandaria'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import Chirp from './Chirp'
import { DataType, Tool, Popup } from '@/util/index'

const tool = new Tool()
const popup = new Popup()

export default {
  components: {
    Chirp
  },
  name: 'decision-logic',
  props: {
    loan: Object
  },
  data () {
    return {
      datatype: DataType,
      assist: {
        tool: tool
      },
      loanData: {},
      dataSource: {},
      isShowPopup: false,
      isShowInstantRefresh: false,
      isShowSearch: false,
      isShowCreateRequestCodeDialog: false,
      isShowChirpData: false,
      isShowDLData: false,
      isShowRequest: false,
      isShowResponse: false,
      type: 1,
      selected: [],
      ibvRequestCodeDataArray: [],
      ibvRequestCodeData: {},
      ibvResponseCodeData: {},
      transactionSummary5: [],
      accountNumberItem: [],
      summaryHeader: LIST_TABLE_HEADER.SUMMARY_HEADER,
      transactionsHeaders: LIST_TABLE_HEADER.TRANSACTION_HEADER,
      providerDefault: '',
      providerOptions: [],
      notes: '',
      chirpData: {},
      providerUrl: '',
      providerList: [],
      requestId: '',
      requestIdList: {},
      loanStatusEnum: [
        DataType.LoanStatus.AGENT_REVIEW.value,
        DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      requestStatus: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  destroyed () {
    this.$eventBus.$off('initDecisionLogic')
  },
  mounted () {
    this.$eventBus.$on('initDecisionLogic', target => {
      this.getProviderList()
    })
  },
  watch: {
    providerDefault (val) {
      if (tool.isNotEmpty(this.requestIdList)) {
        if (val === DataType.IBVProviderType.DECISION_LOGIC.value) {
          if (tool.isNotEmpty(this.requestIdList.DL_RequestId)) {
            this.requestId = this.requestIdList.DL_RequestId
            this.getStatus()
          }
        } else {
          if (tool.isNotEmpty(this.requestIdList.CHIRP_RequestId)) {
            this.requestId = this.requestIdList.CHIRP_RequestId
            this.getStatus()
          }
        }
      }
      this.providerList.map(item => {
        if (tool.getEnumTextByValue(DataType.IBVProviderType, this.providerDefault) === item.name) {
          this.providerUrl = item.logoUrl
        }
      })
    }
  },
  methods: {
    getStatusData () {
      this.isShowPopup = true
      this.getStatus()
    },
    getProviderList () {
      const $this = this
      LoanResourceApi.getProviderList({
        portfolioId: $this.loan.portfolioId
      }, function (result) {
        if (tool.isNotEmpty(result)) {
          if (tool.isNotEmpty(result.providers)) {
            $this.providerList = result.providers
            $this.renderProviderUrl(result.providers)
            $this.initLoanData()
            $this.providerOptions = [DataType.IBVProviderType.DECISION_LOGIC, DataType.IBVProviderType.CHIRP]
          } else {
            $this.providerOptions = []
          }
        }
      })
    },
    renderProviderUrl (providerList) {
      providerList.map(item => {
        if (item.name === tool.getEnumTextByValue(DataType.IBVProviderType, this.providerDefault)) {
          this.providerUrl = item.logoUrl
        }
      })
    },
    decideStatus (item) {
      return item.status === 'pending' ? 'pending' : ''
    },
    manualSelectBankRecords () {
      const selected = this.selected
      if (tool.isEmpty(selected)) {
        this.$swal({
          type: 'info',
          text: 'Please select one transaction',
          showCancelButton: false
        })
        return
      }

      const bankRecordsData = []
      for (const selectItem of selected) {
        let endOfBalance = ''
        const transactionDate = selectItem.transactionDate
        for (const transactionsDataItem of this.transactionSummary5) {
          if (transactionDate === transactionsDataItem.transactionDate) {
            endOfBalance = transactionsDataItem.runningBalance
            break
          }
        }

        const bankRecordsDataItem = {}
        bankRecordsDataItem.loanId = this.loan.id
        bankRecordsDataItem.vob = DataType.VobEnum.IBV.value
        bankRecordsDataItem.payrollDate = selectItem.transactionDate
        bankRecordsDataItem.balance = endOfBalance
        bankRecordsDataItem.payrollType = DataType.PayrollTypeEnum.DIRECT_DEPOSIT.value
        bankRecordsDataItem.amount = selectItem.amount
        bankRecordsData.push(bankRecordsDataItem)
      }
      const bankRecordsDataFinalData = this.convertTime(bankRecordsData)
      const bankRecordsDataFinal = {
        bankRecordsDataFinalData: bankRecordsDataFinalData,
        provider: DataType.IBVProviderType.DECISION_LOGIC.value
      }
      this.$eventBus.$emit('manualSelectBankRecords', bankRecordsDataFinal)
    },
    convertTime (bankRecordsData) {
      const bankRecordsDataFinal = []
      if (tool.isNotEmpty(bankRecordsData)) {
        const key = []
        for (const bankRecord of bankRecordsData) {
          if (!key.includes(bankRecord.payrollDate)) {
            bankRecordsDataFinal.push(bankRecord)
            key.push(bankRecord.payrollDate)
          } else {
            bankRecordsDataFinal[bankRecordsDataFinal.length - 1].amount += bankRecord.amount
          }
        }
      }
      return bankRecordsDataFinal
    },
    getStatus () {
      const $this = this
      const getStatusData = {
        requestId: this.requestId
      }
      LoanResourceApi.getRequestStatus(getStatusData, function (result) {
        const loanUpdateData = {}
        loanUpdateData.loanId = $this.loan.id
        loanUpdateData.ibvStatus = result.status
        loanUpdateData.provider = $this.providerDefault
        loanUpdateData.ibvUpdateType = DataType.IbvUpdateType.GET_REQUEST_STATUS.value
        $this.requestStatus = result.status
        if ($this.providerDefault === DataType.IBVProviderType.CHIRP.value) {
          const chirpRequestStatus = {}
          chirpRequestStatus.requestStatus = result.status
          $this.$eventBus.$emit('chirpRequestStatus', chirpRequestStatus)
          $this.store.commit('setChirpRequestStatus', chirpRequestStatus)
        }
        if ($this.dataSource !== result.status) {
          $this.$eventBus.$emit('createIbvStatus', result.status)
        }
        $this.updateIBVData(loanUpdateData)
        if (result.status === DataType.DecisionLogicRequestCodeStatusEnum.VERIFIED.value) {
          $this.isShowResponse = true
          $this.getReports()
        }
      }, function (result) {
        if ($this.isShowPopup) {
          const message = result?.data?.message || result?.message
          popup.popupForWarning(message)
        }
        $this.isShowPopup = false
      })
    },
    getReports () {
      const $this = this
      const getReportsData = {
        requestId: this.requestId
      }
      LoanResourceApi.getMultipleReportDetails(getReportsData, function (result) {
        if (tool.isNotEmpty(result)) {
          let reportData
          if ($this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
            reportData = JSON.parse(result.rawData)
            $this.isShowDLData = true
            $this.isShowChirpData = false
          } else if ($this.providerDefault === DataType.IBVProviderType.CHIRP.value) {
            reportData = result
            $this.isShowChirpData = true
            $this.isShowDLData = false
          } else {
            $this.isShowChirpData = false
            $this.isShowDLData = false
          }
          if (tool.isNotEmpty(result) && tool.isNotEmpty(result.risk)) {
            $this.$eventBus.$emit('suspectedRisk', result.risk)
          }
          if (tool.isNotEmpty(reportData)) {
            const reportDetail5 = reportData
            $this.uploadData(reportDetail5)
            let loanUpdateData = {}
            if ($this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
              loanUpdateData = {
                loanId: $this.loanId,
                ibvData: JSON.parse(result.rawData),
                provider: $this.providerDefault,
                ibvUpdateType: DataType.IbvUpdateType.GET_MULTIPLE_REPORT.value
              }
            } else {
              loanUpdateData = {
                loanId: $this.loanId,
                rawData: JSON.parse(result.rawData),
                ibvData: {
                  requestData: result.requestData,
                  responseData: result.responseData
                },
                provider: $this.providerDefault,
                ibvUpdateType: DataType.IbvUpdateType.GET_MULTIPLE_REPORT.value
              }
            }
            $this.updateIBVData(loanUpdateData)
          }
        }
      }, function (result) {
        const message = result?.data?.message || result?.message
        popup.popupForWarning(message)
      })
    },
    async initLoanData () {
      const $this = this
      const portfolioId = $this.loan.portfolioId
      let loanData = {}
      const request = {
        loanId: this.loanId,
        feature: 'PERSONAL,BANK,IBV'
      }
      await OriginationApi.getLoanByIdAndFeature(request, function (result) {
        loanData = result
        let ibvListData
        const ibvDataObj = {}
        if (tool.isNotEmpty(result) && tool.isNotEmpty(result.ibvDataList)) {
          result.ibvDataList.map(item => {
            $this.store.commit('setLoan', { loan: result })

            if (item.provider === DataType.IBVProviderType.DECISION_LOGIC.value) {
              ibvDataObj.DLData = item
            } else if (item.provider === DataType.IBVProviderType.CHIRP.value) {
              ibvDataObj.chirpData = item
            }

            if (tool.isNotEmpty(ibvDataObj)) {
              if (tool.isEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
                $this.providerDefault = DataType.IBVProviderType.DECISION_LOGIC.value
                $this.isShowDLData = true
                $this.isShowChirpData = false
              } else if (tool.isEmpty(ibvDataObj.DLData) && tool.isNotEmpty(ibvDataObj.chirpData)) {
                $this.providerDefault = DataType.IBVProviderType.CHIRP.value
                $this.isShowDLData = false
                $this.isShowChirpData = true
              } else if (tool.isNotEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
                $this.isShowDLData = true
                $this.isShowChirpData = true
                if (ibvDataObj.DLData.providerStatus === 1) {
                  $this.providerDefault = DataType.IBVProviderType.DECISION_LOGIC.value
                } else if (ibvDataObj.chirpData.providerStatus === 1) {
                  $this.providerDefault = DataType.IBVProviderType.CHIRP.value
                } else {
                  $this.providerDefault = DataType.IBVProviderType.DECISION_LOGIC.value
                }
              }
            } else {
              $this.providerDefault = DataType.IBVProviderType.DECISION_LOGIC.value
            }

            if (item.provider === $this.providerDefault) {
              $this.dataSource = item
              ibvListData = item
              $this.requestId = item.requestId
            }

            if (item.provider === DataType.IBVProviderType.DECISION_LOGIC.value) {
              $this.requestIdList.DL_RequestId = item.requestId
              loanData.requestCode = item.requestCode
            } else {
              $this.requestIdList.CHIRP_RequestId = item.requestId
            }
          })
          const requestId = $this.dataSource.requestId
          if (tool.isEmpty(requestId)) {
            $this.isShowChirpData = false
            $this.isShowDLData = false
          } else {
            $this.isShowRequest = true
            if (!$this.loanStatusEnum.includes($this.loan.loanStatus)) {
              if (tool.isNotEmpty(ibvListData)) {
                const ibvStatus = ibvListData.ibvStatus
                const ibvData = ibvListData.ibvData
                if (parseInt(ibvStatus) === DataType.DecisionLogicRequestCodeStatusEnum.VERIFIED.value) {
                  $this.isShowResponse = true
                  if (tool.isNotEmpty(ibvData)) {
                    if ($this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
                      // $this.uploadData(JSON.parse(ibvData))
                    }
                  }
                }
              }
            }
          }
        } else {
          $this.providerDefault = DataType.IBVProviderType.DECISION_LOGIC.value
          $this.isShowDLData = false
          $this.isShowChirpData = false
        }
      })

      const portfolioParameter = $this.store.getters.getPortfolioJson
      if (tool.isEmpty(portfolioParameter)) {
        await RuntimeApi.fetchPortfolioParameter(portfolioId, function (result) {
          loanData.portfolioText = result.portfolioName
        })
      } else {
        loanData.portfolioText = portfolioParameter.portfolioName
      }
      $this.loanData = loanData
      if (tool.isNotEmpty(this.dataSource.requestId) && this.dataSource.provider === this.providerDefault) {
        this.getStatus()// 一进来调用第二栏刷新按钮
      }
    },
    async createRequestCodeHandler () {
      this.isShowCreateRequestCodeDialog = true
    },
    createRequestCode () {
      const $this = this
      const loanId = this.loan.id
      let createRequestCodeData = {}
      createRequestCodeData = {
        portfolioId: this.loanData.portfolioId,
        providerEntity: this.providerDefault,
        contactType: DataType.IBVSelectContactType.SEND_BY_EMAIL.value,
        loanId: loanId
      }
      LoanResourceApi.createRequestCode(createRequestCodeData, function (createRequestSuccessResult) {
        if (tool.isNotEmpty(createRequestSuccessResult)) {
          if (tool.isEmpty($this.dataSource)) {
            $this.$eventBus.$emit('createIbvStatus', DataType.DecisionLogicRequestCodeStatusEnum.NOT_STARTED.value)
          }
          $this.getLoanData()
          $this.dataSource.requestId = createRequestSuccessResult.requestId
          $this.dataSource.requestCode = createRequestSuccessResult.requestCode
          $this.requestId = createRequestSuccessResult.requestId
          if ($this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
            $this.requestIdList.DL_RequestId = createRequestSuccessResult.requestId
            $this.isShowChirpData = false
            $this.isShowDLData = true
          } else {
            $this.requestIdList.CHIRP_RequestId = createRequestSuccessResult.requestId
            $this.isShowChirpData = true
            $this.isShowDLData = false
          }
          const loanUpdateData = {}
          loanUpdateData.loanId = loanId
          loanUpdateData.requestCode = createRequestSuccessResult.requestCode
          loanUpdateData.ibvStatus = DataType.DecisionLogicRequestCodeStatusEnum.NOT_STARTED.value
          loanUpdateData.contactType = DataType.IBVSelectContactType.SEND_BY_EMAIL.value
          loanUpdateData.provider = $this.providerDefault
          loanUpdateData.ibvUpdateType = DataType.IbvUpdateType.CREATE_REQUEST_CODE.value
          loanUpdateData.requestId = createRequestSuccessResult.requestId
          $this.updateIBVData(loanUpdateData)
          $this.isShowRequest = true
          $this.$nextTick(() => {
            if ($this.providerDefault === DataType.IBVProviderType.CHIRP.value) {
              const chirpRequestData = {}
              chirpRequestData.requestId = createRequestSuccessResult.requestId
              chirpRequestData.requestCode = createRequestSuccessResult.requestCode
              $this.$eventBus.$emit('chirpRequestData', chirpRequestData)
              $this.store.commit('setChirpRequestData', chirpRequestData)
            }
          })
          if ($this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
            $this.loanData.requestCode = createRequestSuccessResult.requestCode
          }
        }
      }, function (createRequestCodeFailureResult) {
        const message = createRequestCodeFailureResult?.data?.message || createRequestCodeFailureResult?.message
        popup.popupForWarning(message.replace(/<[^>]+>/g, ''))
      })
      this.isShowCreateRequestCodeDialog = false
    },
    getLoanData () {
      const $this = this
      const request = {
        loanId: this.loanId,
        feature: 'PERSONAL,BANK,IBV'
      }
      OriginationApi.getLoanByIdAndFeature(request, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.store.commit('setLoan', { loan: result })
        }
      })
    },
    updateIBVData (data) {
      const $this = this
      OriginationApi.updateIBVDataByLoanId(data, function (result) {
        if (data.ibvStatus === 3) {
          $this.$eventBus.$emit('updateIbvStatus')
        }
      })
    },
    uploadData (ibvData) {
      let reportDetail5Item
      let transactionSummary5
      if (this.providerDefault === DataType.IBVProviderType.DECISION_LOGIC.value) {
        reportDetail5Item = ibvData.reportDetail5[0]
        this.ibvRequestCodeDataArray = ibvData.reportDetail5
        this.ibvRequestCodeData = reportDetail5Item
        const textarea = document.createElement('textarea')
        textarea.innerHTML = reportDetail5Item.notes
        this.notes = textarea.value

        transactionSummary5 = reportDetail5Item.transactionSummaries.transactionSummary5
        let i
        for (i = 0; i < transactionSummary5.length; i++) {
          transactionSummary5[i].index = i
        }
        this.transactionSummary5 = transactionSummary5
        const accountNumberItem = []
        this.accountNumberItem = accountNumberItem
        accountNumberItem.push({ text: reportDetail5Item.accountNumberFound, value: reportDetail5Item.accountNumberFound })
      } else {
        let chirpData = {}
        if (tool.isNotEmpty(ibvData.ibvDataList)) {
          ibvData.ibvDataList.map(item => {
            if (this.providerDefault === item.provider) {
              chirpData = item
            }
          })
        } else {
          chirpData = ibvData
        }
        this.chirpData = chirpData
        if (tool.isNotEmpty(chirpData)) {
          this.isShowChirpData = true
          this.$nextTick(() => {
            this.$eventBus.$emit('setChirpData', chirpData)
          })
        } else {
          this.isShowChirpData = false
        }
      }
    }
  }
}
</script>

<style lang="css">
  .ibv-container {
    font-size: 10px !important;
  }

  .ibv-container .v-card {
    margin-top: 10px !important;
  }

  .ibv-container .v-card + .v-card {
    margin-top: 0 !important;
  }

  .ibv-container .v-card__title {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    padding: 10px;
  }

  .ibv-container .v-card__text {
    font-size: unset;
    line-height: 1.5;
    padding: 10px;
  }

  .ibv-container .v-card__title + .v-card__text {
    padding-top: 0;
  }

  .ibv-container .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 10px;
    vertical-align: bottom;
    line-height: 1.2;
  }

  .ibv-container .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 10px;
  }

  .ibv-container .field-name {
    text-align: left;
  }
  .ibv-container .field-value {
    margin-left: 10px;
  }
  .ibv-container .v-input {
    margin-top: 0;
  }
  .notes-content {
    overflow: auto;
    max-height: 100px;
  }
  .manual-select-content {
    position: fixed;
    bottom: 4%;
    left: 40%;
  }
  .pending {
    color: gray;
  }
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .radio-class {
    height: 36px;
    margin: 0;
    padding: 0;
  }
  .radio-content-class {
    height: 36px;
    margin: 0;
    padding: 0;
  }
  .radio-content-class .v-input__control {
    height: 36px;
  }
  .radio-content-class .v-input__control .v-input__slot {
    height: 36px !important;
    margin: 0;
  }
  .radio-item-class {
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-right: 10px;
  }
  .dialog-title,.dialog-text {
    padding: 16px 24px !important;
  }
  .dialog-layout {
    margin-left: 0;
  }
  .top-title {
    display: flex;
    align-items: flex-end;
    padding-left: 10px;
  }
  .p-l-26 {
    padding-left: 26px !important;
  }
</style>
